import React, { FC, useEffect, useState } from 'react';
import { BASE_URL } from '../../api/config';
import { useGetProjectByTokenQuery } from '../../api/projectsApi';
import { AccessLevelE, ClientTypeE, UserRoleE } from '../../models/enums';
import { UserT } from '../../models/models';
import ViewVideoProject from '../projects/ViewVideoProject/ViewVideoProject';
import { getTokenFromURL } from './helpers/getTokenFromURL';

import styles from './styles.module.scss';

type ShareVideoAdPropTypes = {

}

const ShareVideoAd: FC<ShareVideoAdPropTypes> = () => {
    const [token, setToken] = useState(getTokenFromURL());
    const user: UserT = {
        role: UserRoleE.AdvertisingAgency,
        accessLevel: AccessLevelE.GlobalAdmin,
        clientType: ClientTypeE['Advertising Agency'],
    } as UserT;

    return (
        <ViewVideoProject token={token} user={user}/>
    );
};

export default ShareVideoAd;